import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useLocation, useNavigate } from 'react-router-dom';

import { userInfoAtom } from '@/interfaces/member';
import Login from '@/components/login';
import AdminTemplates from '@/templates/AdminTemplates';
import NoAuthTemplates from '@/templates/NoAuthTemplates';
import UsersView from '@/components/admin/users/UsersView';
import UsersViewDetail from '@/components/admin/users/UsersViewDetail';

export default function AdminContainer() {
  const [target, setTarget] = useState(<></>);
  const { data: userData, isLoading } = useAtomValue(userInfoAtom);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      setTarget(<></>);
      return;
    }

    if (userData) {
      if (userData.isAdmin) {
        const pathname = location.pathname.replace(/^\/admin\/?/, '');
        switch (pathname) {
          case '':
            // TODO: Change to '/admin/main' after implementing main page
            navigate('/admin/users');
            break;
          case 'main':
            navigate('/admin/main/notice');
            break;
          case 'main/notice':
            setTarget(<></>);
            break;
          case 'main/terms':
            setTarget(<></>);
            break;
          case 'main/privacy':
            setTarget(<></>);
            break;

          case 'users':
            navigate('/admin/users/view');
            break;
          case 'users/view':
            setTarget(<UsersView />);
            break;
          case 'users/view/detail':
            setTarget(<UsersViewDetail />);
            break;
          case 'users/leaved':
            setTarget(<></>);
            break;

          case 'sites':
            navigate('/admin/sites/view');
            break;
          case 'sites/view':
            setTarget(<></>);
            break;
          case 'sites/members':
            setTarget(<></>);
            break;

          case 'devices':
            navigate('/admin/devices/sensors');
            break;
          case 'devices/sensors':
            setTarget(<></>);
            break;
          case 'devices/gateways':
            setTarget(<></>);
            break;

          case 'notifications':
            navigate('/admin/notifications/push');
            break;
          case 'notifications/push':
            setTarget(<></>);
            break;
          case 'notifications/templates':
            setTarget(<></>);
            break;
        }
      } else {
        navigate('/', { replace: true });
      }
    } else {
      navigate('/login', { replace: true });
      setTarget(<Login />);
    }
  }, [isLoading, location.pathname, navigate, userData]);

  if (isLoading) return <></>;
  return userData ? <AdminTemplates>{target}</AdminTemplates> : <NoAuthTemplates>{target}</NoAuthTemplates>;
}
